import React from 'react'
import pt from 'prop-types'
import {
  OVERDUE_ON_EXECUTION,
  AVERAGE_LEAD_TIME,
} from '@/constants/serviceDeskMyCity'
import getDeclension from '@/helpers/getDeclension'
import {
  Container,
  Count,
  Text,
  IconContainer,
} from './styles'
import { injectIntl } from 'react-intl'

const Widget = ({
  count,
  text,
  textByCount,
  icon: Icon,
  onClick,
  id,
  intl
}) => {
  return (
    <Container onClick={onClick}>
      <Count customColor={id === OVERDUE_ON_EXECUTION}>
        {id === AVERAGE_LEAD_TIME && count ? `${count.days} ${intl.messages['widgets.day']} ${count.hours} ${intl.messages['widgets.hour']}` : count}
      </Count>
      <Text>{text || getDeclension(count, textByCount)}</Text>
      <IconContainer>
        <Icon />
      </IconContainer>
    </Container>
  )
}

Widget.propTypes = {
  count: pt.number.isRequired,
  id: pt.string.isRequired,
  text: pt.string,
  textByCount: pt.arrayOf(pt.string),
  icon: pt.string.isRequired,
  onClick: pt.func.isRequired,
}
Widget.defaultProps = {
  text: '',
  textByCount: [],
}

export default injectIntl(Widget)
